import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.set";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import _classCallCheck from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _get from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/observer/mutationobserver
 */

/* globals window */
import Observer from "./observer";
import ViewSelection from "../selection";
import { startsWithFiller, getDataWithoutFiller } from "../filler";
import { isEqualWith } from 'lodash-es';
/**
 * Mutation observer class observes changes in the DOM, fires {@link module:engine/view/document~Document#event:mutations} event, mark view
 * elements as changed and call {@link module:engine/view/renderer~Renderer#render}.
 * Because all mutated nodes are marked as "to be rendered" and the
 * {@link module:engine/view/renderer~Renderer#render} is called, all changes will be reverted, unless the mutation will be handled by the
 * {@link module:engine/view/document~Document#event:mutations} event listener. It means user will see only handled changes, and the editor
 * will block all changes which are not handled.
 *
 * Mutation Observer also take care of reducing number of mutations which are fired. It removes duplicates and
 * mutations on elements which do not have corresponding view elements. Also
 * {@link module:engine/view/observer/mutationobserver~MutatedText text mutation} is fired only if parent element do not change child list.
 *
 * Note that this observer is attached by the {@link module:engine/view/view~View} and is available by default.
 *
 * @extends module:engine/view/observer/observer~Observer
 */

var MutationObserver = /*#__PURE__*/function (_Observer) {
  _inherits(MutationObserver, _Observer);

  var _super = _createSuper(MutationObserver);

  function MutationObserver(view) {
    var _this;

    _classCallCheck(this, MutationObserver);

    _this = _super.call(this, view);
    /**
     * Native mutation observer config.
     *
     * @private
     * @member {Object}
     */

    _this._config = {
      childList: true,
      characterData: true,
      characterDataOldValue: true,
      subtree: true
    };
    /**
     * Reference to the {@link module:engine/view/view~View#domConverter}.
     *
     * @member {module:engine/view/domconverter~DomConverter}
     */

    _this.domConverter = view.domConverter;
    /**
     * Reference to the {@link module:engine/view/view~View#_renderer}.
     *
     * @member {module:engine/view/renderer~Renderer}
     */

    _this.renderer = view._renderer;
    /**
     * Observed DOM elements.
     *
     * @private
     * @member {Array.<HTMLElement>}
     */

    _this._domElements = [];
    /**
     * Native mutation observer.
     *
     * @private
     * @member {MutationObserver}
     */

    _this._mutationObserver = new window.MutationObserver(_this._onMutations.bind(_assertThisInitialized(_this)));
    return _this;
  }
  /**
   * Synchronously fires {@link module:engine/view/document~Document#event:mutations} event with all mutations in record queue.
   * At the same time empties the queue so mutations will not be fired twice.
   */


  _createClass(MutationObserver, [{
    key: "flush",
    value: function flush() {
      this._onMutations(this._mutationObserver.takeRecords());
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "observe",
    value: function observe(domElement) {
      this._domElements.push(domElement);

      if (this.isEnabled) {
        this._mutationObserver.observe(domElement, this._config);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "enable",
    value: function enable() {
      _get(_getPrototypeOf(MutationObserver.prototype), "enable", this).call(this);

      var _iterator = _createForOfIteratorHelper(this._domElements),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var domElement = _step.value;

          this._mutationObserver.observe(domElement, this._config);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "disable",
    value: function disable() {
      _get(_getPrototypeOf(MutationObserver.prototype), "disable", this).call(this);

      this._mutationObserver.disconnect();
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(MutationObserver.prototype), "destroy", this).call(this);

      this._mutationObserver.disconnect();
    }
    /**
     * Handles mutations. Deduplicates, mark view elements to sync, fire event and call render.
     *
     * @private
     * @param {Array.<Object>} domMutations Array of native mutations.
     */

  }, {
    key: "_onMutations",
    value: function _onMutations(domMutations) {
      // As a result of this.flush() we can have an empty collection.
      if (domMutations.length === 0) {
        return;
      }

      var domConverter = this.domConverter; // Use map and set for deduplication.

      var mutatedTexts = new Map();
      var mutatedElements = new Set(); // Handle `childList` mutations first, so we will be able to check if the `characterData` mutation is in the
      // element with changed structure anyway.

      var _iterator2 = _createForOfIteratorHelper(domMutations),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var mutation = _step2.value;

          if (mutation.type === 'childList') {
            var element = domConverter.mapDomToView(mutation.target); // Do not collect mutations from UIElements.

            if (element && element.is('uiElement')) {
              continue;
            }

            if (element && !this._isBogusBrMutation(mutation)) {
              mutatedElements.add(element);
            }
          }
        } // Handle `characterData` mutations later, when we have the full list of nodes which changed structure.

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(domMutations),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _mutation = _step3.value;

          var _element = domConverter.mapDomToView(_mutation.target); // Do not collect mutations from UIElements.


          if (_element && _element.is('uiElement')) {
            continue;
          }

          if (_mutation.type === 'characterData') {
            var text = domConverter.findCorrespondingViewText(_mutation.target);

            if (text && !mutatedElements.has(text.parent)) {
              // Use text as a key, for deduplication. If there will be another mutation on the same text element
              // we will have only one in the map.
              mutatedTexts.set(text, {
                type: 'text',
                oldText: text.data,
                newText: getDataWithoutFiller(_mutation.target),
                node: text
              });
            } // When we added first letter to the text node which had only inline filler, for the DOM it is mutation
            // on text, but for the view, where filler text node did not existed, new text node was created, so we
            // need to fire 'children' mutation instead of 'text'.
            else if (!text && startsWithFiller(_mutation.target)) {
              mutatedElements.add(domConverter.mapDomToView(_mutation.target.parentNode));
            }
          }
        } // Now we build the list of mutations to fire and mark elements. We did not do it earlier to avoid marking the
        // same node multiple times in case of duplication.
        // List of mutations we will fire.

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var viewMutations = [];

      var _iterator4 = _createForOfIteratorHelper(mutatedTexts.values()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var mutatedText = _step4.value;
          this.renderer.markToSync('text', mutatedText.node);
          viewMutations.push(mutatedText);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var _iterator5 = _createForOfIteratorHelper(mutatedElements),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var viewElement = _step5.value;
          var domElement = domConverter.mapViewToDom(viewElement);
          var viewChildren = Array.from(viewElement.getChildren());
          var newViewChildren = Array.from(domConverter.domChildrenToView(domElement, {
            withChildren: false
          })); // It may happen that as a result of many changes (sth was inserted and then removed),
          // both elements haven't really changed. #1031

          if (!isEqualWith(viewChildren, newViewChildren, sameNodes)) {
            this.renderer.markToSync('children', viewElement);
            viewMutations.push({
              type: 'children',
              oldChildren: viewChildren,
              newChildren: newViewChildren,
              node: viewElement
            });
          }
        } // Retrieve `domSelection` using `ownerDocument` of one of mutated nodes.
        // There should not be simultaneous mutation in multiple documents, so it's fine.

      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var domSelection = domMutations[0].target.ownerDocument.getSelection();
      var viewSelection = null;

      if (domSelection && domSelection.anchorNode) {
        // If `domSelection` is inside a dom node that is already bound to a view node from view tree, get
        // corresponding selection in the view and pass it together with `viewMutations`. The `viewSelection` may
        // be used by features handling mutations.
        // Only one range is supported.
        var viewSelectionAnchor = domConverter.domPositionToView(domSelection.anchorNode, domSelection.anchorOffset);
        var viewSelectionFocus = domConverter.domPositionToView(domSelection.focusNode, domSelection.focusOffset); // Anchor and focus has to be properly mapped to view.

        if (viewSelectionAnchor && viewSelectionFocus) {
          viewSelection = new ViewSelection(viewSelectionAnchor);
          viewSelection.setFocus(viewSelectionFocus);
        }
      }

      this.document.fire('mutations', viewMutations, viewSelection); // If nothing changes on `mutations` event, at this point we have "dirty DOM" (changed) and de-synched
      // view (which has not been changed). In order to "reset DOM" we render the view again.

      this.view.forceRender();

      function sameNodes(child1, child2) {
        // First level of comparison (array of children vs array of children) – use the Lodash's default behavior.
        if (Array.isArray(child1)) {
          return;
        } // Elements.


        if (child1 === child2) {
          return true;
        } // Texts.
        else if (child1.is('text') && child2.is('text')) {
          return child1.data === child2.data;
        } // Not matching types.


        return false;
      }
    }
    /**
     * Checks if mutation was generated by the browser inserting bogus br on the end of the block element.
     * Such mutations are generated while pressing space or performing native spellchecker correction
     * on the end of the block element in Firefox browser.
     *
     * @private
     * @param {Object} mutation Native mutation object.
     * @returns {Boolean}
     */

  }, {
    key: "_isBogusBrMutation",
    value: function _isBogusBrMutation(mutation) {
      var addedNode = null; // Check if mutation added only one node on the end of its parent.

      if (mutation.nextSibling === null && mutation.removedNodes.length === 0 && mutation.addedNodes.length == 1) {
        addedNode = this.domConverter.domToView(mutation.addedNodes[0], {
          withChildren: false
        });
      }

      return addedNode && addedNode.is('element', 'br');
    }
  }]);

  return MutationObserver;
}(Observer);
/**
 * Fired when mutation occurred. If tree view is not changed on this event, DOM will be reverted to the state before
 * mutation, so all changes which should be applied, should be handled on this event.
 *
 * Introduced by {@link module:engine/view/observer/mutationobserver~MutationObserver}.
 *
 * Note that because {@link module:engine/view/observer/mutationobserver~MutationObserver} is attached by the
 * {@link module:engine/view/view~View} this event is available by default.
 *
 * @see module:engine/view/observer/mutationobserver~MutationObserver
 * @event module:engine/view/document~Document#event:mutations
 * @param {Array.<module:engine/view/observer/mutationobserver~MutatedText|module:engine/view/observer/mutationobserver~MutatedChildren>}
 * viewMutations Array of mutations.
 * For mutated texts it will be {@link module:engine/view/observer/mutationobserver~MutatedText} and for mutated elements it will be
 * {@link module:engine/view/observer/mutationobserver~MutatedChildren}. You can recognize the type based on the `type` property.
 * @param {module:engine/view/selection~Selection|null} viewSelection View selection that is a result of converting DOM selection to view.
 * Keep in
 * mind that the DOM selection is already "updated", meaning that it already acknowledges changes done in mutation.
 */

/**
 * Mutation item for text.
 *
 * @see module:engine/view/document~Document#event:mutations
 * @see module:engine/view/observer/mutationobserver~MutatedChildren
 *
 * @typedef {Object} module:engine/view/observer/mutationobserver~MutatedText
 *
 * @property {String} type For text mutations it is always 'text'.
 * @property {module:engine/view/text~Text} node Mutated text node.
 * @property {String} oldText Old text.
 * @property {String} newText New text.
 */

/**
 * Mutation item for child nodes.
 *
 * @see module:engine/view/document~Document#event:mutations
 * @see module:engine/view/observer/mutationobserver~MutatedText
 *
 * @typedef {Object} module:engine/view/observer/mutationobserver~MutatedChildren
 *
 * @property {String} type For child nodes mutations it is always 'children'.
 * @property {module:engine/view/element~Element} node Parent of the mutated children.
 * @property {Array.<module:engine/view/node~Node>} oldChildren Old child nodes.
 * @property {Array.<module:engine/view/node~Node>} newChildren New child nodes.
 */


export { MutationObserver as default };